import api from '../api'
import { getWithSign } from 'src/public-resource/libs/yiapiRequest.js'
import { throttle } from '../../../../public-resource/libs/utils/index'
import Bridge from '../../../../frontend-lib/lib/Bridge'
import Swiper from 'swiper'
import '../style/psychicCoachList.scss'
import FindACoach from '../components/FindACoach.js'

let IS_APP = window.$platform.isYixinliApp
let myBridge = new Bridge()

class PsychicCoachList {
  constructor() {
    this.loading = false
    this.tabIdx = 0
    this.page = [1, 1]
    this.hasMore = [true, true]
    this.type = ['hot', 'new']
    this.chat_coach_user = null
    this.pay_coach_user = null
    this.BroadcastText = ''

    this.getAdData()
    this.renderAd()
    this.renderFixedButton()
    this.getListData()
    this.bindEvent()
  }
  async renderAd() {
    await this.getAdText()
    if (!this.BroadcastText) return
    // text
    let html = `
    <div class="Broadcast-box">
      <div class="Broadcast">
        <img
          src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/39b209f2c69a4be1b62a2c46ed1d94be.png"
          alt=""
          srcset=""
        />
        <div class="des">${this.BroadcastText}</div>
        <i class="yxl-font yxl-font-skip"></i>
      </div>
    </div>
    `
    $('.psychicCoach_ul').before(html)
  }
  getAdText() {
    return getWithSign(api.getPsychicCoachAd, {
      name: 'heart-search-service-list-ad',
      size: 1
    }).then(res => {
      console.log(res)
      if (res.data.code === 0) {
        let list = res.data.data
        if (list && list.length) {
          this.BroadcastText = list[0].title
        }
      }
    })
  }
  renderFixedButton() {
    let that = this
    let html = `
      <div class="psychicCoachWrap-FixedButton${
        window.$platform.isAndroid && window.$platform.isYixinliApp
          ? ' isAndroid'
          : ''
      }">立即找教练</div>
    `
    $('.psychicCoachWrap').append(html)
    $('.psychicCoachWrap-FixedButton').on('click', function(e) {
      FindACoach({
        chat_coach_user: that.chat_coach_user,
        pay_coach_user: that.pay_coach_user
      })
    })
  }
  getAdData() {
    getWithSign(api.getPsychicCoachAd, {
      size: 3,
      name: 'app-psychic-coach-index'
    }).then(({ data: { code, data } }) => {
      // data = [{"id":"12570","title":"\u5e7f\u544a1","url":"http:\/\/www.xinli001.com\/info\/100467172?from=liebiao","image":"https:\/\/ossimg.xinli001.com\/2021423\/1619142770392iYo5T57gULwoZhDXYcoqVXMgVUlh7xFK.jpg?x-oss-process=image\/quality,Q_80","object_name":"app-psychic-coach-index","title2":"","sort":"0","start":"2021-04-23 09:52:24","end":"2082-02-04 09:52:26"},{"id":"12572","title":"  \u5e7f\u544a3","url":"https:\/\/www.xinli001.com\/user\/1008189083?from=liebiao","image":"https:\/\/ossimg.xinli001.com\/2021423\/1619143044562w4HrPH8dPxTMWxp3kG1ECwnV3fUQKkAu.jpg?x-oss-process=image\/quality,Q_80","object_name":"app-psychic-coach-index","title2":"","sort":"0","start":"2021-04-06 09:56:58","end":"2086-08-07 12:57:01"},{"id":"12571","title":"  \u5e7f\u544a2","url":"http:\/\/www.xinli001.com\/info\/100467775?from=liebiao","image":"https:\/\/ossimg.xinli001.com\/2021423\/1619142940756oe40dknyG0743KGe5pycC53eMAcebTKA.jpg?x-oss-process=image\/quality,Q_80","object_name":"app-psychic-coach-index","title2":"","sort":"0","start":"2021-04-01 09:55:18","end":"2062-08-16 09:55:19"}]
      let l = data.length
      if (code === 0 && l) {
        let $psychicCoachWrap = $('.psychicCoachWrap')
        $psychicCoachWrap.addClass('hadBanner')

        let template =
          '<div class="coachBanner"><div class="swiper-container" id="coachBanner"><div class="swiper-wrapper">'
        data.forEach(item => {
          template += `<div class="swiper-slide">
              <img src="${item.image}" alt="">
            </div>`
        })
        template += '</div><div class="swiper-pagination"></div></div></div>'

        $psychicCoachWrap.prepend(template)

        setTimeout(() => {
          let options = {
            direction: 'horizontal',
            autoplay: 3000,
            autoplayDisableOnInteraction: false
          }
          if (l > 1) {
            options.loop = true
            options.pagination = '.swiper-pagination'
          }
          let coachBannerSwiper = new Swiper('#coachBanner', options)

          $('#coachBanner').on('click', '.swiper-slide', function(e) {
            let url = data[coachBannerSwiper.realIndex].url
            if (IS_APP) {
              myBridge.call('openWebView', {
                url,
                isCurrentPageOpen: 0
              })
            } else {
              window.location.href = url
            }
          })
        })
      }
    })
  }
  getListData() {
    if (this.loading || !this.hasMore[this.tabIdx]) return
    this.loading = true
    $('.loading-more').show()

    return getWithSign(api.getPsychicCoachList, {
      page: this.page[this.tabIdx],
      type: this.type[this.tabIdx],
      size: 10
    })
      .then(res => {
        res = res.data
        this.loading = false
        $('.loading-more').hide()
        if (+res.code === 0) {
          if (!this.chat_coach_user) {
            this.chat_coach_user = res.data.chat_coach_user
          }
          if (!this.pay_coach_user) {
            this.pay_coach_user = res.data.pay_coach_user
          }

          this.page[this.tabIdx]++

          if (!res.data.list.length) {
            this.hasMore[this.tabIdx] = false
            return
          }
          $(`.coachList.${this.type[this.tabIdx]}`).append(
            this.renderList(res.data.list)
          )
        } else {
          window.toast(res.message)
        }
      })
      .catch(e => {
        console.error(e)
        this.loading = false
        $('.loading-more').hide()
      })
  }
  getUserDes(work_status = 0) {
    // work_status 状态,0休息，1服务中，2空闲
    let list = [
      {
        text: '已休息',
        className: 'rest'
      },
      {
        text: '服务中',
        className: 'busy'
      },
      {
        text: '空闲',
        className: 'free'
      }
    ]
    return list[work_status]
  }
  renderList(data) {
    let coachList = ''
    data.forEach(item => {
      coachList += `
        <li class="item-wrp" userId=${item.user_id}>
        ${item.tip_tag ? `<div class="tag">${item.tip_tag}</div>` : ''}
        <div class="avatar-box">
          <img src="${item.avatar}" alt="${item.nickname}" class="avatar" />
          <div class="user-des ${this.getUserDes(item.work_status).className}">
            ${this.getUserDes(item.work_status).text}
          </div>
        </div>
          <div class="right">
            <p class="top">
              <span class="name">${item.nickname}</span>
              <span class="reserve">找教练</span>
            </p>
            <ul class="tag-list">
              ${(item.tag || '')
                .split(',')
                .filter(tag => !!tag.trim())
                .map(tag => `<li>${tag}</li>`)
                .join('')}
            </ul>
            <p class="text">${item.self_introduction}</p>
          </div>
        </li>
      `
    })
    return coachList
  }
  bindEvent() {
    let that = this
    $('.psychicCoachWrap .tab-list li').click(function() {
      let $this = $(this)
      if ($this.hasClass('active')) return

      that.tabIdx = $this.index()

      $this
        .addClass('active')
        .siblings()
        .removeClass('active')

      $('.psychicCoach_ul > ul')
        .eq(that.tabIdx)
        .show()
        .siblings()
        .hide()

      if (that.page[that.tabIdx] === 1) {
        that.getListData()
      }
    })

    $(document).delegate('.psychicCoach_ul .item-wrp', 'click', function() {
      let url = `${
        api.static
      }/msite/index.html#/heart-search/service-index?id=${$(this).attr(
        'userId'
      )}`
      if (IS_APP) {
        myBridge.call('openWebView', {
          url,
          isCurrentPageOpen: 0,
          hideNavigationBar: 1
        })
      } else {
        window.location.href = url
      }
    })

    let scroll = throttle(function() {
      // console.log($(this).innerHeight(), $(this).scrollTop(), this.scrollHeight)
      let height = $(this).innerHeight()
      let scrollHeight = this.scrollHeight
      let scrollTop = $(this).scrollTop()
      if (scrollTop > 0 && height + scrollTop > scrollHeight - 20) {
        that.getListData()
      }
    }, 500)
    $('.psychicCoachWrap').on('scroll', scroll)
  }
}

module.exports = PsychicCoachList



// WEBPACK FOOTER //
// ./src/pages/ask/askIndex/modules/psychicCoachList.js